import { getTimelineItem } from 'helpers'
import { Button, Card, CardBody } from 'reactstrap'

const HistoryTransactionSection = ({
  transaction,
  isAdjustBySeller,
  isConfirmOnBehalfBuyer,
  onOpenOriginalOrderModal,
  onOpenFulfillmentModal,
}) => {
  const isSellerAdjustment = Boolean(isAdjustBySeller)

  const fulfillmentDate =
    transaction?.history?.sellerFillCreatedDate

  return (
    <Card className="shadow-sm border-0 mb-3">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="fw-semibold mb-3">Alur transaksi</h6>
        </div>
        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
          {transaction?.history?.offeredDate
            ? getTimelineItem(
              'Penjual mengirim penawaran',
              transaction?.history?.offeredDate,
            )
            : null}
          {transaction?.history?.createdDate &&
            transaction?.orderDetail?.type === 'BUY'
            ? getTimelineItem(
              'Pembeli membuat pesanan',
              transaction?.history?.createdDate,
               transaction?.history?.linkOrder && onOpenOriginalOrderModal && (
                <Button
                  color="link"
                  className="p-0 text-decoration-none text-primary fw-semibold"
                  style={{ fontSize: '0.8rem' }}
                  onClick={onOpenOriginalOrderModal}
                >
                  Lihat Pesanan
                </Button>
              ),
            )
            : null}
          {transaction?.history?.createdDate &&
            transaction?.orderDetail?.type === 'SELL'
            ? getTimelineItem(
              'Penjual membuat pesanan',
              transaction?.history?.createdDate,
               transaction?.history?.linkOrder && onOpenOriginalOrderModal && (
                <Button
                  color="link"
                  className="p-0 text-decoration-none text-primary fw-semibold"
                  style={{ fontSize: '0.8rem' }}
                  onClick={onOpenOriginalOrderModal}
                >
                  Lihat Pesanan
                </Button>
              ),
            )
            : null}
          {transaction?.history?.checkerApprovedDate
            ? getTimelineItem(
              'Pemeriksa menerima pesanan',
              transaction?.history?.checkerApprovedDate,
            )
            : null}
          {transaction?.history?.checkerRejectDate
            ? getTimelineItem(
              'Pemeriksa menolak pesanan',
              transaction?.history?.checkerRejectDate,
            )
            : null}
          {transaction?.history?.buyerConfirmDate
            ? getTimelineItem(
              'Pembeli menerima pesanan',
              transaction?.history?.buyerConfirmDate,
            )
            : null}
          {transaction?.history?.buyerRejectedDate
            ? getTimelineItem(
              'Pembeli menolak pesanan',
              transaction?.history?.buyerRejectedDate,
            )
            : null}
          {transaction?.history?.sellerRejectedDate
            ? getTimelineItem(
              'Penjual menolak pesanan',
              transaction?.history?.sellerRejectedDate,
            )
            : null}
          {transaction?.history?.sellerConfirmDate
            ? getTimelineItem(
              'Penjual menerima pesanan',
              transaction?.history?.sellerConfirmDate,
            )
            : null}
          {fulfillmentDate
            ? getTimelineItem(
              'Pemenuhan pesanan',
              fulfillmentDate,
               transaction?.history?.linkSellerFills && onOpenFulfillmentModal && (
                <Button
                  color="link"
                  className="p-0 text-decoration-none text-primary fw-semibold"
                  style={{ fontSize: '0.8rem' }}
                  onClick={onOpenFulfillmentModal}
                >
                  Lihat Hasil Pemenuhan
                </Button>
              ),
            )
            : null}
          {transaction?.history?.disputeDate
            ? getTimelineItem(
              isSellerAdjustment
                ? 'Penjual mengajukan penyesuaian pesanan'
                : 'Pembeli mengajukan penyesuaian pesanan',
              transaction?.history?.disputeDate,
            )
            : null}
          {transaction?.history?.sellerApprovedDisputeDate &&
            !isSellerAdjustment
            ? getTimelineItem(
              'Penjual menerima penyesuaian pesanan',
              transaction?.history?.sellerApprovedDisputeDate,
            )
            : null}
          {transaction?.history?.sellerRejectedDisputeDate
            ? getTimelineItem(
              'Penjual menolak penyesuaian pesanan',
              transaction?.history?.sellerRejectedDisputeDate,
            )
            : null}
          {transaction?.history?.releaseDate && (
            <>
              {getTimelineItem(
                isConfirmOnBehalfBuyer
                  ? 'Penjual mengonfirmasi barang diterima atas nama pembeli'
                  : 'Pembeli mengonfirmasi penerimaan barang',
                transaction?.history?.releaseDate,
              )}
              {getTimelineItem(
                'Transaksi selesai',
                transaction?.history?.updatedAt,
              )}
            </>
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default HistoryTransactionSection
